@if (isLoading || isSubmitting) {
  <mat-spinner class="mx-a" diameter="30"></mat-spinner>
}

@if (!isLoading && !isSubmitting && !isSubmitted) {
  <form [formGroup]="userForm" class="user-edit" style="display: flex; flex-direction: column; align-content: stretch">
    @if ((isModeUpdate() || isModeSelfUpdate()) && !isJustDriver) {
      <p>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" />
        </mat-form-field>
      </p>
    }
    @if (!isModeSelfUpdate()) {
      <p>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>User role</mat-label>
          <mat-select formControlName="userType">
            @for (userType of userTypes; track userType) {
              <mat-option [value]="userType">{{ userType.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </p>
    }
    <p>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>First Name</mat-label>
        <input matInput autocomplete="off" formControlName="givenName" required />
        @if (ngGivenName?.invalid && ngGivenName?.errors?.required) {
          <mat-error> First name is required. </mat-error>
        }
      </mat-form-field>
    </p>
    <p>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>Last Name</mat-label>
        <input matInput autocomplete="off" formControlName="familyName" required />
        @if (ngFamilyName?.invalid && ngFamilyName?.errors?.required) {
          <mat-error> Last name is required. </mat-error>
        }
      </mat-form-field>
    </p>
    @if (isModeCreate() && ngEmailPrefix) {
      <p>
        <mat-form-field appearance="outline" color="accent">
          <mat-label>Email</mat-label>
          <input matInput autocomplete="off" formControlName="emailPrefix" required />
          <span matTextSuffix>{{ configuration.driverSuffix }}</span>
          @if (ngEmailPrefix?.invalid && ngEmailPrefix?.errors?.required) {
            <mat-error> Email is required. </mat-error>
          }
          @if (ngEmailPrefix?.invalid && ngEmailPrefix?.errors?.pattern) {
            <mat-error> Email format is not valid. </mat-error>
          }
        </mat-form-field>
      </p>
    }
    @if (ngPhoneNumber) {
      <p class="phone-number-forms">
        <mat-form-field appearance="outline" color="accent" style="width: 145px">
          <mat-label>Country Code</mat-label>
          <mat-select formControlName="countryCode" required>
            <mat-option [value]="'+1'">(+1)</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" color="accent" style="width: unset; flex-grow: 1">
          <mat-label>Phone Number</mat-label>
          <input matInput autocomplete="off" type="tel" formControlName="phoneNumberWithOutCountryCode" />
          @if (ngPhoneNumber?.invalid && ngPhoneNumber?.errors?.pattern) {
            <mat-error> Please enter a valid phone number. (10 digits) </mat-error>
          }
        </mat-form-field>
      </p>
    }
    @if (ngHideFromLogin && !isModeSelfUpdate()) {
      <p>
        <mat-slide-toggle labelPosition="before" formControlName="hideFromLogin" [hideIcon]="true">
          <mat-label>Hide from PlowOps mobile login</mat-label>
        </mat-slide-toggle>
      </p>
    }
    @if (uiError) {
      <p class="ui-error">
        {{ uiError }}
      </p>
    }
  </form>
}

@if (isSubmitted) {
  <p>
    @if (isModeCreate()) {
      User created.
    }
    @if (isModeUpdate() || isModeSelfUpdate()) {
      User updated.
    }
  </p>
}
